import styled from "styled-components";
import { typography } from "src/theme";
import { colors } from "src/theme/colors";
import device from "src/constants/media";

export const Wrapper = styled.div`
  display: none;
  font-family: ${typography.fontFamily};
  margin: 50px 0;

  @media ${device.tablet} {
    display: block;
  }
`;
export const Title = styled.div`
  font-size: 24px;
  color: ${colors.grey};
  font-weight: 500;
  margin-bottom: 20px;
`;
export const LabelsWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;
export const LabelContainer = styled.div`
  background-color: ${colors.greyVeryLight};
  border-radius: 6px;
  padding: 16px 10px;
  display: flex;
  flex-direction: row;
  margin-right: 12px;
`;
export const Icon = styled.div`
  margin-right: 14px;
`;
export const Label = styled.div`
  font-size: 20px;
  color: ${colors.grey};
  font-weight: 500;
`;
